var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"w-full",staticStyle:{"height":"1990px","width":"100%","border":"none"},attrs:{"src":"app_introduce.html","loading":"lazy","referrerpolicy":"no-referrer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }